import { render, staticRenderFns } from "./StoresDistributionCard.vue?vue&type=template&id=c71c2532&scoped=true"
import script from "./StoresDistributionCard.vue?vue&type=script&lang=js"
export * from "./StoresDistributionCard.vue?vue&type=script&lang=js"
import style0 from "./StoresDistributionCard.vue?vue&type=style&index=0&id=c71c2532&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71c2532",
  null
  
)

export default component.exports